<!-- =========================================================================================
    File Name: CompanyListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
      <vx-card title="Products">
        <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

        <div class="vx-row no-gutter">
          <div class="vx-col w-full">
            <label for="foobar">{{ `${selectedProducts.length} Products` }}</label>
            <v-select id="foobar" multiple label="_name" :value="selectedProducts" :reduce="product => product.product_id" @input="productSelectionChanged" :options="unSelectedProducts" />
          </div>
        </div>

      </vx-card>

</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {cyclopediaAnalysisCategoryHelpers} from '@/models/helpers';
  import api from '@/http/api';

  export default {
    components: {
    },
    data() {
      return {
        loading: false,
        types: types,
        jsonHtml: jsonHtml,
        helpers: cyclopediaAnalysisCategoryHelpers,
        selectedProductIds: [],
        allProducts: [],
      }
    },
    props: {
      category: {
        type: types.CyclopediaAnalysisCategory(),
        required: true,
        default: () => {
          return new types.CyclopediaAnalysisCategory()
        }
      },
      products: {
        type: Array,
        required: true,
        default: () => {
          return [];
        }
      },
    },
    mounted() {
      // window.addEventListener("keyup", function(e) {
      //   if (e.key === 'Escape') {
      //   }
      // });
    },
    watch: {
      category(oldVal, newVal) {
        if (newVal.id === oldVal.id) return;
        this.setUpWorkingData();
      },
      products(oldVal, newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.setUpWorkingData();
      },
    },
    computed: {
      selectedProducts() {
        return this.allProducts.filter((product) => {
          return this.selectedProductIds.indexOf(product.product_id) !== -1;
        });
      },
      unSelectedProducts() {
        return this.allProducts.filter((product) => {
          return this.selectedProductIds.indexOf(product.product_id) === -1;
        });
      },
    },
    methods: {
      async productSelectionChanged(newSelectedProducts) {
        if (newSelectedProducts.length === this.selectedProductIds.length) return;
        const productAdded = newSelectedProducts.length > this.selectedProductIds.length;

        let success = false;
        if (productAdded) {
          let addedProductId = newSelectedProducts.filter(x => !this.selectedProductIds.includes(x))[0];
          success = await api.addProductToAnalysisCategory(addedProductId, this.category);
        } else {
          let removedProductId = this.selectedProductIds.filter(x => !newSelectedProducts.includes(x))[0];
          success = await api.deleteProductFromAnalysisCategory(removedProductId, this.category);
        }

        this.showNotification(success, productAdded ? `Product${success ? '' : ' NOT'} added to ${this.helpers.getPreferredName(this.category)}` : `Product${success ? '' : ' NOT'} removed from ${this.helpers.getPreferredName(this.category)}`);

        this.selectedProductIds = newSelectedProducts;

      },
      setUpWorkingData() {
        this.selectedProductIds = this.category.products.map((product) => product.product_id);
        this.allProducts = JSON.parse(JSON.stringify(this.products));
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
